import React, { useState } from "react";
import "../../../Styling/artistsignup.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { show_country_list } from "../../../Common/data";
import {
  loadContriesAction,
  ticketDetailsAction,
  ticketDetailsErrorsAction,
} from "../../../redux/actions";
import validateStepOne from "../../ArtistSignUpPage/ArtistSignupForms/validateStepOne";
import validateTicket from "./validateTicket";
import Modal from "react-modal";
import NumberFormat from "react-number-format";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import TEDER_CONFIG from "../../../Common/config";
import { trackPurchase } from "../../../Common/tracking";

const stripePromise = loadStripe(TEDER_CONFIG().StripePublishableKey);

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#fff",
      fontFamily: '"Catamaran", sans-serif',
      fontSize: "16px",
      "::placeholder": { color: "#aab7c4" },
    },
    invalid: { color: "#fa755a", iconColor: "#fa755a" },
  },
};

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const currentState = useSelector((state) => state.TederReducerState);
  const dispatch = useDispatch();
  const ticket = currentState.purchaseTicket;

  const [ticketsPurchased, setticketsPurchased] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [cardError, setCardError] = useState(null);
  let Scroll = require("react-scroll");
  let scroller = Scroll.scroller;
  let Element = Scroll.Element;

  const inputClassName = "form-control artist-textbox-style";

  const handleChange = (e) => {
    let { name, value } = e.target;
    let ticketDetails = { ...ticket, [name]: value };
    dispatch(ticketDetailsAction(ticketDetails));
  };

  const handlePhone = (value) => {
    const ticketDetails = { ...ticket, phoneNo: value.formattedValue };
    dispatch(ticketDetailsAction(ticketDetails));
  };

  const handleBlur = () => {
    const error1 = validateStepOne(currentState.purchaseTicket);
    const error2 = validateTicket(currentState.purchaseTicket);
    let allErrors = Object.assign({}, error1, error2);
    dispatch(ticketDetailsErrorsAction(allErrors));
  };

  const isFreeShow = currentState.viewShowDetails && Number(currentState.viewShowDetails.showTicketPrice) === 0;

  const handlePurchase = async () => {
    if (!currentState.purchaseTicketErrors.isValid) {
      handleBlur();
      alert("Please complete the form");
      scroller.scrollTo("purchase", { smooth: true });
      return;
    }

    setIsloading(true);
    setCardError(null);

    let stripeTokenId = null;

    if (!isFreeShow) {
      if (!stripe || !elements) {
        setIsloading(false);
        return;
      }

      const cardElement = elements.getElement(CardElement);
      const { error, token } = await stripe.createToken(cardElement, {
        name: `${ticket.firstName} ${ticket.lastName}`,
        address_line1: ticket.address,
        address_city: ticket.city,
        address_state: ticket.state,
        address_zip: ticket.zipCode,
        address_country: "US",
      });

      if (error) {
        setCardError(error.message);
        setIsloading(false);
        return;
      }
      stripeTokenId = token.id;
    }

    const ticketInfo = {
      Event_ID: currentState.viewShowDetails.showID,
      EmailID: ticket.email,
      FirstName: ticket.firstName,
      LastName: ticket.lastName,
      PhoneNo: ticket.phoneNo || "",
      Address: ticket.address,
      City: ticket.city,
      State: ticket.state,
      Country: ticket.country,
      ZipCode: ticket.zipCode,
      TicketsCount: parseInt(ticket.ticketCount, 10),
      stripe_token: stripeTokenId,
    };

    try {
      const api = (await import("../../../Common/api")).default;
      const config = TEDER_CONFIG();
      const apiHandler = new api(config.Endpoint, config.Resources);
      apiHandler.setDefaultHeaders1();
      const data = await apiHandler.get_resource("purchase_ticket", "POST", ticketInfo, "");

      if (data.code === "Success") {
        setticketsPurchased(data.TicketNoList);
        setIsloading(false);
        setIsOpen(true);
        clearTicketForm();

        const showDetails = currentState.viewShowDetails;
        trackPurchase({
          value: (showDetails.ticketPrice || 0) * ticketInfo.TicketsCount,
          currency: "USD",
          eventId: ticketInfo.Event_ID,
          eventName: showDetails.eventName || "",
          ticketCount: ticketInfo.TicketsCount,
        });
      } else {
        setIsloading(false);
        alert("Please enter a valid credit card.");
        scroller.scrollTo("purchase", { smooth: true });
      }
    } catch (err) {
      console.error(err);
      setIsloading(false);
      alert("Please contact our support team at support@onteder.com.");
    }
  };

  const clearTicketForm = () => {
    const blankForm = {
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      country: "United States of America",
      zipCode: "",
      email: "",
      phoneNo: "",
      ticketCount: 1,
    };
    dispatch(ticketDetailsAction(blankForm));
  };

  if (currentState.countries.length === 0) {
    const get_country_list = async () => {
      const response = await show_country_list.then((result) => {
        return JSON.parse(result.countryList);
      });
      dispatch(loadContriesAction(response));
    };
    get_country_list();
  }

  return (
    <Element name="purchase">
      <div className="container">
        <h3 className="text-center">Purchase a ticket</h3>
        <br />
        <div className="row">
          <div className="col-md">
            <form className="form ticket-form">
              <div className="form-row">
                <div className="form-group col-lg">
                  <label htmlFor="firstName">FIRST NAME</label>
                  <input
                    id="firstName"
                    type="text"
                    name="firstName"
                    className={inputClassName}
                    placeholder="First Name"
                    value={ticket.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <small className="small-green-text">
                    {currentState.purchaseTicketErrors.firstName}
                  </small>
                </div>
                <div className="form-group col-lg">
                  <label htmlFor="lastName">LAST NAME</label>
                  <input
                    id="lastName"
                    type="text"
                    name="lastName"
                    className={inputClassName}
                    placeholder="Last Name"
                    value={ticket.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <small className="small-green-text">
                    {currentState.purchaseTicketErrors.lastName}
                  </small>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="address">ADDRESS</label>
                <input
                  id="address"
                  type="text"
                  name="address"
                  className={inputClassName}
                  placeholder="Address"
                  value={ticket.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <small className="small-green-text">
                  {currentState.purchaseTicketErrors.address}
                </small>
              </div>
              <div className="form-row">
                <div className="form-group col-lg">
                  <label htmlFor="city">CITY</label>
                  <input
                    id="city"
                    type="text"
                    name="city"
                    className={inputClassName}
                    placeholder="City Name"
                    value={ticket.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <small className="small-green-text">
                    {currentState.purchaseTicketErrors.city}
                  </small>
                </div>
                <div className="form-group col-lg-3">
                  <label
                    htmlFor="State"
                    className={
                      ticket.country !== "United States of America"
                        ? "state-label-disabled"
                        : ""
                    }
                  >
                    STATE
                  </label>
                  {ticket.country !== "United States of America" ? (
                    <input
                      id="state"
                      className="form-control artist-textbox-style teder-select"
                      name="state"
                      type="text"
                      disabled
                      value="Select State"
                    />
                  ) : (
                    <select
                      id={
                        ticket.state === "Select State" || ticket.state === ""
                          ? "state-placeholder"
                          : "state"
                      }
                      className="form-control artist-textbox-style teder-select"
                      name="state"
                      value={ticket.state}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option>Select State</option>
                      <option>AK</option><option>AL</option><option>AR</option>
                      <option>AZ</option><option>CA</option><option>CO</option>
                      <option>CT</option><option>DE</option><option>FL</option>
                      <option>GA</option><option>HI</option><option>IA</option>
                      <option>ID</option><option>IL</option><option>IN</option>
                      <option>KS</option><option>KY</option><option>LA</option>
                      <option>MA</option><option>MD</option><option>ME</option>
                      <option>MI</option><option>MN</option><option>MO</option>
                      <option>MS</option><option>MT</option><option>NC</option>
                      <option>ND</option><option>NE</option><option>NH</option>
                      <option>NJ</option><option>NM</option><option>NV</option>
                      <option>NY</option><option>OH</option><option>OK</option>
                      <option>OR</option><option>PA</option><option>RI</option>
                      <option>SC</option><option>SD</option><option>TN</option>
                      <option>TX</option><option>UT</option><option>VA</option>
                      <option>VT</option><option>WA</option><option>WI</option>
                      <option>WV</option><option>WY</option>
                    </select>
                  )}
                  <small className="small-green-text">
                    {currentState.purchaseTicketErrors.state}
                  </small>
                </div>
                <div className="form-group col-lg-3">
                  <label htmlFor="zipCode">ZIP CODE</label>
                  <input
                    id="zipCode"
                    type="text"
                    name="zipCode"
                    className={inputClassName}
                    placeholder="Zip Code"
                    value={ticket.zipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength={5}
                  />
                  <small className="small-green-text">
                    {currentState.purchaseTicketErrors.zipCode}
                  </small>
                </div>
              </div>
              <div className="form-group">
                <label>COUNTRY</label>
                <select
                  id="country"
                  className={"form-control artist-textbox-style teder-select"}
                  name="country"
                  value={ticket.country}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {currentState.countries.map((element) => (
                    <option key={element.ID}> {element.CountryName} </option>
                  ))}
                </select>
                <small className="small-green-text">
                  {currentState.purchaseTicketErrors.country}
                </small>
              </div>
              <div className="form-group form-inputs">
                <label htmlFor="email">EMAIL</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  className={inputClassName}
                  placeholder="Email"
                  value={ticket.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <small className="small-green-text">
                  {currentState.purchaseTicketErrors.email}
                </small>
              </div>
              <div className="form-group">
                <label htmlFor="phoneNo">PHONE NUMBER</label>
                <NumberFormat
                  type="tel"
                  id="phoneNo"
                  name="phoneNo"
                  format="(###) ###-####"
                  mask="_"
                  className={inputClassName}
                  placeholder="Phone Number"
                  onValueChange={handlePhone}
                  required
                />
              </div>
              <br />
            </form>
          </div>
          <div className="col-md-5">
            <form className="form ticket-form">
              <div className="form-group">
                <label className="text-center">NUMBER OF TICKETS</label>
                <br />
                <input
                  id="ticketCount"
                  type="number"
                  name="ticketCount"
                  className={inputClassName}
                  value={ticket.ticketCount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className="form-group">
                <label>CARD DETAILS</label>
                {isFreeShow ? (
                  <div style={{ padding: "12px", color: "#4ecca3", fontWeight: "bold" }}>
                    This is a FREE show - no payment required!
                  </div>
                ) : (
                  <div
                    style={{
                      border: "1px solid #4a4a4a",
                      borderRadius: "4px",
                      padding: "12px",
                      backgroundColor: "#1a1a2e",
                    }}
                  >
                    <CardElement options={CARD_ELEMENT_OPTIONS} />
                  </div>
                )}
                {cardError && (
                  <small style={{ color: "#fa755a" }}>{cardError}</small>
                )}
              </div>
            </form>
          </div>
          <br />
          <br />
          <br />
        </div>
        <div className="d-flex justify-content-center">
          <span
            className="red-teder-btn"
            onClick={handlePurchase}
            style={{ opacity: (!isFreeShow && !stripe) ? 0.5 : 1, pointerEvents: (!isFreeShow && !stripe) ? "none" : "auto" }}
          >
            Purchase
          </span>
        </div>
        <Modal
          isOpen={isLoading}
          ariaHideApp={false}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Loading Modal"
        >
          <div className="teder-modal-container">
            <div className="modal-body">
              <div className="teder-modal-title text-center">Loading...</div>
              <div className="teder-modal-body"></div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalIsOpen}
          ariaHideApp={false}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Purchase Modal"
        >
          <div className="teder-modal-container">
            <div className="modal-body">
              <div className="teder-modal-title text-center">
                THANK YOU FOR YOUR PURCHASE!
              </div>
              <div className="teder-modal-body">
                <p>
                  Please save your ticket number below. An email confirmation
                  was also sent.
                </p>
                <div className="teder-modal-subtitle">
                  Your Ticket Number(s):
                </div>
                <ul className="list-group">
                  {ticketsPurchased.map((value) => (
                    <li
                      key={value}
                      className="list-group-item list-group-item-danger"
                    >
                      {value}
                    </li>
                  ))}
                </ul>
              </div>
              <br />
              <br />
              <div className="text-center">
                <button
                  type="button"
                  className="green-teder-btn"
                  onClick={() => setIsOpen(false)}
                >
                  close
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </Element>
  );
};

const PurchaseTicket = () => {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm />
    </Elements>
  );
};

export default PurchaseTicket;
